<template>
  <div class="icon-info">
    <div
      class="icon-data home-border"
      @click.stop="toggleIcon"
      :class="[IconStatus ? 'success' : '', errorStatus ? 'error' : '']"
    >
      <template v-if="list.length">
        <div v-for="(item, index) in list" :key="index" class="icon-list">
          <div class="icon-image" :style="item.style"></div>
          <p>{{ item.name }}</p>
        </div>
      </template>
      <template v-else>
        <div
          v-for="(item, index) in defaultList"
          :key="index"
          class="icon-list"
        >
          <div class="icon-image" :style="item.style">
            <i class="iconfont icon-weibiaoti-1-03"></i>
          </div>
          <p>{{ item.name }}</p>
        </div>
      </template>
    </div>
    <!-- <draw-icon @close="close" :status="IconStatus" :list="list" /> -->
    <common-template
      :status="IconStatus"
      :list="list"
      @remove="remove"
      @error="error"
      @close="close"
      :maxLen="maxLen"
      ref="drawerIcon"
      :submitText="'图文导航'"
    >
      <div class="draw-title" slot="info">
        <h3>图文导航</h3>
        <p>图文导航最多可配置6张，最少4张。图片、链接、 名称 均为必填项。</p>
        <p>图片建议尺寸: 36 * 36</p>
      </div>
    </common-template>
  </div>
</template>

<script>
// import drawIcon from "./drawIcon.vue";
import { Home } from "@/config/axios/new_api";
import CommonTemplate from "../commonTemplate.vue";
export default {
  components: { CommonTemplate },
  data() {
    return {
      IconStatus: false,
      list: [],
      errorStatus: false,
      maxLen: 6,
      defaultStatus: false,
      defaultList: [
        {
          style:
            "background: linear-gradient(180deg, #B4EC51 0%, #429321 100%);",
          name: "配置文字图标",
        },
        {
          style:
            "background: linear-gradient(180deg, #FAD961 0%, #F76B1C 100%);",
          name: "配置文字图标",
        },
        {
          style:
            "background: linear-gradient(180deg, #F5515F 0%, #9F041B 100%);",
          name: "配置文字图标",
        },
        {
          style:
            "background: linear-gradient(315deg, #3023AE 0%, #C86DD7 100%);",
          name: "配置文字图标",
        },
        {
          style:
            "background: linear-gradient(360deg, #0553EE 0%, #02A6F1 73%, #00BFFF 100%);",
          name: "配置文字图标",
        },
        {
          style:
            "background: linear-gradient(180deg, #00DCAA 0%, #EB6464 100%);",
          name: "配置文字图标",
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      Home.getData({ type: 3, random: Math.random() }).then((res) => {
        if (Array.isArray(res.data) && res.data.length) {
          this.defaultStatus = true;
          this.list = res.data.map((item) => {
            item.name_edit_status = false;
            item.style = `background-image: url(${item.url})`;
            item.directories_name = item.directories_id ? item.file_name : "";
            item.template_name = item.template_id ? item.file_name : "";
            return item;
          });
        } else {
          //let newArr = Array(6);
          this.defaultStatus = false;
          // this.list = newArr.fill({
          //   name: `-`, // 轮播图默认传空
          //   img_name: "", // 模板分类传空
          //   path_type: 0, // 模板分类默认传0  1 文件 2 模板
          //   directories_id: "", // 目录ID字符串  必须path_type === 1  不是目录传空
          //   directories_name: "",
          //   template_id: "", // 必须path_type === 2   模板ID
          //   template_name: "",
          //   url: "", // 图片地址
          //   name_edit_status: false,
          // });
        }
      });
    },
    editData(newItems, index) {
      this.$set(this.list, index, newItems);
    },
    close() {
      this.IconStatus = false;
      if (this.list.length < 4) {
        this.errorStatus = true;
        this.$message.error("图文导航最少需要配置4张");
      } else {
        let list = this.list.filter((item) => {
          if (
            item.name &&
            item.url &&
            item.img_name &&
            ((item.path_type === 1 && item.directories_id) ||
              (item.path_type && item.template_id))
          ) {
            return item;
          }
        });
        if (list.length < this.list.length) {
          this.$refs.drawerIcon.save();
          this.errorStatus = true;
        } else {
          this.$refs.drawerIcon.save();
          this.errorStatus = false;
        }
      }
    },
    toggleIcon() {
      this.IconStatus = !this.IconStatus;
    },
    remove(newItems) {
      this.list = newItems;
    },
    error(status) {
      // 提交错误信息 需要在轮播图画红线
      this.errorStatus = status;
    },
    submit() {
      this.$refs.drawerIcon.save();
    },
  },
};
</script>

<style lang="scss">
.icon-info {
  height: 100px;
  width: 100%;
  .icon-data {
    width: 100%;
    height: 100px;
  }
  .icon-list {
    width: 184px;
    height: 80px;
    float: left;
    margin-right: 19px;
    line-height: 36px;
    padding: 22px 20px;
    font-size: 16px;
    color: #3b3946;
    cursor: pointer;
    border-radius: 8px;
    position: relative;
    z-index: 10;
    &:hover {
      background: $hoverColor;
    }
    &:last-child {
      margin-right: 0;
    }
    .icon-image {
      width: 36px;
      height: 36px;
      border-radius: 8px;
      float: left;
      margin-right: 12px;
      text-align: center;
      background-size: 100% 100%;
      i {
        font-size: 18px;
        color: #fff;
      }
    }
  }
}
</style>
